import React, { useState, useEffect } from "react";
import { AuthService } from "../../../services";
import ReactPaginate from "react-paginate";
import { Button, Table } from "react-bootstrap";
import {
  formatAmount,
  handleConsoleError,
} from "../../../utils/common-methods";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../../constants/routes";
import { injectModels } from "../../../redux/injectModels";
import { toast } from "react-toastify";
import { ShopFrontService } from "../../../services";
import { addDefaultImg } from "../../../utils/common-methods";
//import _ from "lodash";

const ShopFrontList = (props) => {
  const loginUser = AuthService.getLoginUser();
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();

  const rowsPerPage = 10; // Number of rows to display per page
  const offset = currentPage * rowsPerPage; // Calculate the offset based on current page
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  useEffect(() => {
    getShopFrontData();
  }, []);

  //get
  const getShopFrontData = async () => {
    try {
      if (loginUser) {
        props.application.setLoading(true);
        const res = await ShopFrontService.getTraderShopFrontList(
          loginUser?.id
        );
        if (res?.isSuccess && res?.data?.length > 0) {
          setFilteredData(res?.data);
        } else {
          setFilteredData([]);
        }
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const handleEdit = async (id) => {
    try {
      //ShopFrontService.setShopFrontId(id);
      navigate(routes.CREATE_EDIT_SHOPFRONT.replace(":id", id));
    } catch (error) {}
  };

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };

  //****** Add New Data *********/
  const handleCreateShopFront = async (e) => {
    // ShopFrontService.removeShopFrontId();
    try {
      navigate(routes.CREATE_ADD_SHOPFRONT);
    } catch (error) {
      console.log("error", error);
    }
  };

  //************* Delete Method ******** */
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this record?"
    );
    if (!confirmDelete) {
      return;
    }
    try {
      props.application.setLoading(true);
      const response = await ShopFrontService.DeleteShopFront(id);
      if (response?.isSuccess) {
        toast.success("Record deleted successfully");
        await getShopFrontData();
      } else {
        toast.error(response?.message || "Failed to delete the record");
      }
    } catch (error) {
      const message=handleConsoleError(error)
      toast.error(
        error?.message || message
      );
    } finally {
      props.application.setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <section className="edit-form-table">
        <div className="container mt-3">
          <div className="verifier-buttton">
            <Button onClick={handleCreateShopFront}>Add Items</Button>{" "}
          </div>
          <div className="table-responsive">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Product Title</th>
                  <th>Description</th>
                  <th>Image</th>
                  <th>Price</th>
                   {/* <th>Status</th>  */}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData && paginatedData.length > 0 ? (
                  <React.Fragment>
                    {paginatedData.map((item, idx) => {
                      return (
                        <tr key={idx}>
                          <td>{calculateSNo(idx)}</td>
                          <td>{item?.productTitle}</td>

                          <td>{item?.productDescription}</td>
                          <td>
                            <img
                              className="img-fluid"
                              style={{
                                maxWidth: "100px",
                              }}
                              alt=""
                              src={item?.imageUrl}
                              onError={addDefaultImg}
                            ></img>
                          </td>
                          <td>£{formatAmount(item?.price)}</td>
                           {/* <td>
                            {item.status === true ? (
                              <i className="ri-check-fill"></i>
                            ) : (
                              <i className="ri-close-circle-line"></i>
                            )}
                          </td>  */}

                          <td>
                            <div className="delete-create">
                              <Link
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleEdit(item?.id);
                                }}
                                style={{ marginRight: "10px" }}
                              >
                                <i className="ri-pencil-line"></i>
                              </Link>

                              <Link
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleDelete(item?.id);
                                }}
                                style={{ marginRight: "10px" }}
                              >
                                <i className="ri-delete-bin-line"></i>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </React.Fragment>
                ) : (
                  <tr>
                    <td colSpan="10 mt-2">No results found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <div className="table-footer">
            <p className="mb-3">
              <strong>Total Count: {filteredData.length}</strong>
            </p>
            {filteredData.length === 0 ? "" : renderPagination()}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default injectModels(["application"])(ShopFrontList);
